<template>
  <div id="app" :style="cssVariables">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: window.innerWidth + "px",
      windowHeight: window.innerHeight + "px",
    };
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    cssVariables() {
      return {
        "--windowWidth": `${this.windowWidth}`,
        "--window-height": `${this.windowHeight}`,
      };
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth + "px";
      this.windowHeight = window.innerHeight + "px";
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>
